import { getMicroserviceBaseContext } from "../../../constants/api-routing";

const contactCenterContext = getMicroserviceBaseContext('contact-center');
const roleplayContext = getMicroserviceBaseContext('roleplay');
const conversationsContext = getMicroserviceBaseContext('conversations');
const evaluationContext = getMicroserviceBaseContext('evaluation');

export const CONTACT_CENTER = {
    CREATE_REQUEST: `${contactCenterContext}create_request`,
    GET_REQUEST_LIST: `${contactCenterContext}get_request_list`,
    UPDATE_REQUEST_ACTIVITY_LOG: `${contactCenterContext}update_request_activity_log`,
    REQUEST_WITH_LOGS: (request_id: number) => `${contactCenterContext}request_with_logs/${request_id}`,
    FETCH_REQUEST_WITH_LOGS_BY_USER: `${contactCenterContext}fetch_request_with_logs_by_user`,

    // Get Request(feedback) Status Metadata List
    GET_REQUEST_STATUS_METADATA_LIST: `${conversationsContext}fetch_feedback_status_metadata_list`,

    // Roleplay Feedback APIs
    ROLEPLAY_FEEDBACK_LIST: (bu: string) => `${roleplayContext}get_roleplay_feedback_list/${bu}`,
    CREATE_ROLEPLAY_FEEDBACK: `${roleplayContext}create_roleplay_conversation_feedback`,
    UPDATE_ROLEPLAY_FEEDBACK: (id: number) => `${roleplayContext}update_roleplay_conversation_feedback/${id}`,
    GET_ROLEPLAY_FEEDBACK_BY_SESSION: (sessionId: number) => `${roleplayContext}get_roleplay_feedback_by_session_id/${sessionId}`,
    GET_ROLEPLAY_CONVERSATIONS: (sessionId: number) => `${roleplayContext}get_roleplay_conversations_by_session_id/${sessionId}`,
    UPDATE_ROLEPLAY_FEEDBACK_ACTIVITY_LOG: `${roleplayContext}update_roleplay_feedback_activity_log`,
    FETCH_ROLEPLAY_FEEDBACK_WITH_LOGS_BY_USER: `${roleplayContext}roleplay_feedback/fetch_with_logs_by_user`,
    ROLEPLAY_FEEDBACK_WITH_LOGS: (feedbackId: number) => `${roleplayContext}roleplay_feedback_with_logs/${feedbackId}`,

    // Contact Center Assignment
    CREATE_CONTACT_CENTER_ASSIGNMENT: `${contactCenterContext}assign_to_category`,
    CREATE_CONTACT_CENTER_ASSIGNMENT_CHAT_FEEDBACK: `${conversationsContext}create_contact_center_assignment_chat_feedback`,
    CREATE_CONTACT_CENTER_ASSIGNMENT_ROLEPLAY: `${roleplayContext}create_contact_center_assignment_roleplay`,
    AVAILABLE_CATEGORIES: `${contactCenterContext}get_available_categories`,
    GET_ASSIGNMENT_HISTORY: (referenceId: number) => `${contactCenterContext}get_assignment_history/${referenceId}`,
    GET_FEEDBACKS_BY_CATEGORY: `${contactCenterContext}get_feedbacks_by_category`,
    GET_ROLEPLAY_FEEDBACKS_BY_CATEGORY: `${contactCenterContext}get_roleplay_feedbacks_by_category`,
    GET_REQUESTS_BY_CATEGORY: `${contactCenterContext}get_requests_by_category`,
    SEARCH_REQUESTOR_USERS: `${contactCenterContext}search_requestor_users`,
};
